module.exports = __webpack_public_path__ + "static/images/components/ArenaTooltip/images/map-placeholder.158636f3.png";


//////////////////
// WEBPACK FOOTER
// ./components/ArenaTooltip/images/map-placeholder.png
// module id = 2489
// module chunks = 11